<template>

    <transition name="slide-fade">

        <div class="video-shade" v-if="shaded">

            <slot></slot>

        </div>

    </transition>

</template>


<script>

    export default {

        name: 'VideoShade',

        props: {
            shaded: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {

            }
        },

        created() {

        },

        methods: {

        }

    }

</script>


<style lang="scss" scoped>

    .video-shade {
        background: linear-gradient(135deg, $gradient-start 0%, $gradient-end 100%);
        width: 100%;
        height: 100%;
        box-shadow: 0 42px 30px $black-25;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 50;

        /*&::after {
            content: '';
            background-image: url(/static/images/gradient-blender_tile.png);
            width: 100%;
            height: 100%;
            overflow: hidden;
            opacity: 0.5;
            mix-blend-mode: soft-light;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transform: translate3d(0, 0, 0);
        }*/
    }

</style>

<style lang="scss">

    .slide-fade-enter-active {
        transition: all .3s ease-in-out;
    }
    .slide-fade-leave-active {
        transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(-800px);
        opacity: 0;
    }

</style>
